export const contactSalesText = "Contact Sales";

const glideEnterpriseURL = "https://www.glideapps.com/enterprise";
const contactSalesURL = "https://www.glideapps.com/contact/enterprise";

export function makeContactSalesURL(source?: string): string {
    if (source === undefined) {
        return contactSalesURL;
    }
    return `${contactSalesURL}?source=${encodeURIComponent(source)}`;
}

interface GlideEnterpriseOptions {
    readonly contactSales: boolean;
    readonly source: string;
    readonly extraParams: readonly string[];
}

export function makeGlideEnterpriseURL({
    contactSales = false,
    source,
    extraParams = [],
}: Partial<GlideEnterpriseOptions> = {}): string {
    const options: string[] = [];
    if (contactSales) {
        options.push("contactSales=true");
    }
    if (source !== undefined) {
        options.push(`source=${encodeURIComponent(source)}`);
    }
    options.push(...extraParams);
    if (options.length === 0) {
        return glideEnterpriseURL;
    }
    return glideEnterpriseURL + "?" + options.join("&");
}
